import { render, staticRenderFns } from "./ColumnEmptyState.vue?vue&type=template&id=288ea7ee"
import script from "./ColumnEmptyState.vue?vue&type=script&lang=js"
export * from "./ColumnEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports